export interface MockCampaign {
  campaignId: string;
  campaignName: string;
}

/** Stable ids so a snapshot of the tiles is reproducible run to run. */
export const MOCK_CAMPAIGNS: MockCampaign[] = [
  {
    campaignId: "1f0a5c40-0001-4c00-9000-a0b1c2d30001",
    campaignName: "Meta · Summer Skin",
  },
  {
    campaignId: "1f0a5c40-0002-4c00-9000-a0b1c2d30002",
    campaignName: "Instagram · Hair Restoration",
  },
  {
    campaignId: "1f0a5c40-0003-4c00-9000-a0b1c2d30003",
    campaignName: "Meta · Free Consultation Week",
  },
  {
    campaignId: "1f0a5c40-0004-4c00-9000-a0b1c2d30004",
    campaignName: "Google · Whitening Offer",
  },
  {
    campaignId: "1f0a5c40-0005-4c00-9000-a0b1c2d30005",
    campaignName: "TikTok · Laser Retargeting",
  },
];

/**
 * Which campaign each appointment came from, and which came from none.
 * A repeating pattern rather than RNG: visual snapshots would flake on random
 * shares, and the uneven weighting is what makes the tiles look like a real
 * spend split instead of five equal columns. `-1` is an organic patient.
 */
const CAMPAIGN_PATTERN = [
  0, 0, -1, 1, 0, 2, -1, 1, 3, 0, 1, -1, 2, 0, 4, 1, -1, 0, 2, 3,
];

export const campaignForIndex = (index: number): MockCampaign | null => {
  const slot = CAMPAIGN_PATTERN[index % CAMPAIGN_PATTERN.length] ?? -1;

  return slot < 0 ? null : (MOCK_CAMPAIGNS[slot] ?? null);
};
